"use strict";

module.exports = require("./lib/DayPicker");
module.exports.DateUtils = require("./lib/DateUtils");
module.exports.LocaleUtils  = require("./lib/LocaleUtils");



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-day-picker/DayPicker.js
 ** module id = 984
 ** module chunks = 2 4 5 6 13 14 18 22 23 24 25 35 36 38 39 41 51 52 54 55 57 59 62
 **/